import React, { lazy, Suspense, useEffect, useRef } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';

import { Account } from './Components/useContext/Account';

import Login from './Components/pages/Login';
import Sidebar from './Components/estructura/Sidebar';
import Topbar from './Components/estructura/Topbar';
import PaletaComandos from './Components/estructura/PaletaComandos';
import AtajosGlobales from './Components/estructura/AtajosGlobales';
import NoEncontrada from './Components/estructura/NoEncontrada';
import Precarga from './Components/estructura/Precarga';
import AvisoVersion from './Components/estructura/AvisoVersion';
import { MarcoProvider, useMarco } from './Components/estructura/MarcoContext';
import { cargarPantalla } from './pantallas';

/* Cada pantalla se descarga cuando se abre (ver src/pantallas.js); el ingreso va en el archivo principal para que
   aparezca de inmediato. */
const p = (ruta) => lazy(cargarPantalla(ruta));
const Register = p('/register');
const Laorden = p('/laorden');
const Resultados = p('/resultados');
const Labordenpago = p('/labordenpago');
const Examenemp = p('/examenemp');
const Lista = p('/lista');
const Consultav3 = p('/consultav3');
const Mediospago = p('/mediospago');
const Undnegocios = p('/undnegocios');
const Agencias = p('/agencias');
const Combos = p('/combos');
const Combosdet = p('/combosdet');
const Feriados = p('/feriados');
const Ipsconsec = p('/ipsconsec');
const Labdepends = p('/labdepends');
const Labempresas = p('/labempresas');
const Lablistas = p('/lablistas');
const Labseccion = p('/labseccion');
const Labvalores = p('/labvalores');
const Medicos = p('/medicos');
const Ocupaciones = p('/ocupaciones');
const Tipomuestras = p('/tipomuestras');
const Unidades = p('/unidades');
const Vinculaciones = p('/vinculaciones');
const Opciones = p('/opciones');
const Roleopcion = p('/roleopcion');
const Roles = p('/roles');
const Usuarios = p('/usuarios');
const Labtarifas = p('/labtarifas');
const Pacientes = p('/pacientes');
const Pacientesing = p('/pacientesing');
const Usuariorole = p('/usuariorole');
const Examenana = p('/examenana');
const Labnormal = p('/labnormal');
const Dashboard = p('/dashboard');
const Zbi = p('/zbi');
const Reglasimp = p('/reglasimp');
const Ordenlab = p('/ordenlab');
const InterfazRuby = p('/interfazruby');
const InterfazFus2000 = p('/interfazfus2000');
const OrderPinCapture = p('/orderpincapture');
const Uploadimages = p('/uploadimages');
const RepAnexo = p('/repanexo');
const Interfaces = p('/interfaces');
const Rips = p('/rips');
const DescargarJSON = p('/descargarjson');
const Logcaja = p('/logcaja');
const Bonosreyfals = p('/bonosreyfals');
const Facturacion = p('/facturacion');
const Consulta = p('/consulta');
const Cartera = p('/cartera');
const CargaImagenS3 = p('/cargaimagens3');
const Diagnosticos = p('/diagnosticos');
const Consultafacturas = p('/consultafacturas');
const Entregares = p('/entregares');
const Usupendientes = p('/usupendientes');
const Tracking = p('/tracking');
const Landsticker = p('/landsticker');
const Funnel = p('/funnel');
const Consultadep = p('/consultadep');

const RUTAS_SIN_MARCO = ['/', '/login', '/register'];

/* Mientras baja una pantalla (la primera vez que se abre) */
function Cargando() {
  return (
    <div className="sym-cargando" role="status" aria-live="polite">
      <span className="sym-cargando__barra" />
      <span className="spinner-border spinner-border-sm" aria-hidden="true" />
      <span>Cargando pantalla…</span>
    </div>
  );
}

/* Marco del panel: menú lateral + barra superior + contenido (que se desplaza solo él).
   En el ingreso (login/registro) o sin sesión, la pantalla ocupa todo. */
function Marco({ children }) {
  const { pathname } = useLocation();
  const { usuario } = useMarco();
  const contenido = useRef(null);

  // al cambiar de pantalla, el contenido vuelve arriba
  useEffect(() => { if (contenido.current) contenido.current.scrollTop = 0; }, [pathname]);

  if (!usuario || RUTAS_SIN_MARCO.includes(pathname.toLowerCase())) {
    return <Suspense fallback={<Cargando />}>{children}</Suspense>;
  }

  return (
    <div className="sym-app">
      <a href="#contenido" className="sym-saltar">Saltar al contenido</a>
      <Sidebar />
      <div className="sym-principal">
        <Topbar />
        <main className="sym-contenido" id="contenido" tabIndex={-1} ref={contenido}>
          <Suspense fallback={<Cargando />}>{children}</Suspense>
        </main>
      </div>
      <PaletaComandos />
      <AtajosGlobales />
      <Precarga />
      <AvisoVersion />
    </div>
  );
}

function App() {
  return (
    <Account>
      <BrowserRouter>
        <MarcoProvider>
          <Marco>
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/login" element={<Login />} />
              <Route path="/home" element={<Navigate to="/Dashboard" replace />} />
              <Route path="/laorden" element={<Laorden />} />

              <Route path="/Medico" element={<Navigate to="/Medicos" replace />} />
              <Route path="/MedioDePagos" element={<Mediospago />} />
              <Route path="/Resultados" element={<Resultados />} />
              <Route path="/Mediospago" element={<Mediospago />} />
              <Route path="/Labordenpago" element={<Labordenpago />} />
              <Route path="/Examenemp" element={<Examenemp />} />
              <Route path="/Lista" element={<Lista />} />
              <Route path="/Consultav3" element={<Consultav3 />} />
              <Route path="/Undnegocios" element={<Undnegocios />} />
              <Route path="/Agencias" element={<Agencias />} />
              <Route path="/Combos" element={<Combos />} />
              <Route path="/Combosdet" element={<Combosdet />} />
              <Route path="/Feriados" element={<Feriados />} />
              <Route path="/Ipsconsec" element={<Ipsconsec />} />
              <Route path="/Labdepends" element={<Labdepends />} />
              <Route path="/Labempresas" element={<Labempresas />} />
              <Route path="/Lablistas" element={<Lablistas />} />
              <Route path="/Labseccion" element={<Labseccion />} />
              <Route path="/Labvalores" element={<Labvalores />} />
              <Route path="/Medicos" element={<Medicos />} />
              <Route path="/Ocupaciones" element={<Ocupaciones />} />
              <Route path="/Tipomuestras" element={<Tipomuestras />} />
              <Route path="/Unidades" element={<Unidades />} />
              <Route path="/Vinculaciones" element={<Vinculaciones />} />
              <Route path="/Opciones" element={<Opciones />} />
              <Route path="/Roleopcion" element={<Roleopcion />} />
              <Route path="/Roles" element={<Roles />} />
              <Route path="/Usuarios" element={<Usuarios />} />
              <Route path="/Dashboard" element={<Dashboard />} />
              <Route path="/Labtarifas" element={<Labtarifas />} />
              <Route path="/Pacientes" element={<Pacientes />} />
              <Route path="/Usuariorole" element={<Usuariorole />} />
              <Route path="/Examenana" element={<Examenana />} />
              <Route path="/Labnormal" element={<Labnormal />} />
              <Route path="/Zbi" element={<Zbi />} />
              <Route path="/Reglasimp" element={<Reglasimp />} />
              <Route path="/Ordenlab" element={<Ordenlab />} />
              <Route path="/Pacientesing" element={<Pacientesing />} />

              <Route path="/InterfazRuby" element={<InterfazRuby />} />
              <Route path="/InterfazFus2000" element={<InterfazFus2000 />} />
              <Route path="/OrderPinCapture" element={<OrderPinCapture />} />
              <Route path="/Uploadimages" element={<Uploadimages />} />
              <Route path="/RepAnexo" element={<RepAnexo />} />
              <Route path="/Interfaces" element={<Interfaces />} />
              <Route path="/Rips" element={<Rips />} />

              <Route path="/DescargarJSON" element={<DescargarJSON />} />
              <Route path="/Logcaja" element={<Logcaja />} />
              <Route path="/Bonosreyfals" element={<Bonosreyfals />} />
              <Route path="/Facturacion" element={<Facturacion />} />
              <Route path="/Consulta" element={<Consulta />} />
              <Route path="/Cartera" element={<Cartera />} />
              <Route path="/CargaImagenS3" element={<CargaImagenS3 />} />
              <Route path="/Diagnosticos" element={<Diagnosticos />} />
              <Route path="/Consultafacturas" element={<Consultafacturas />} />
              <Route path="/Entregares" element={<Entregares />} />
              <Route path="/Usupendientes" element={<Usupendientes />} />
              <Route path="/Tracking" element={<Tracking />} />
              <Route path="/Landsticker" element={<Landsticker />} />
              <Route path="/Funnel" element={<Funnel />} />
              <Route path="/Consultadep" element={<Consultadep />} />

              <Route path="*" element={<NoEncontrada />} />
            </Routes>
          </Marco>
        </MarcoProvider>
      </BrowserRouter>
    </Account>
  );
}

export default App;
